const { CarouselElement } = window.BAO.Carousel
const { setInitialised, useArrows, useScrollbar } = window.BAO.Carousel.plugins

export class ProductCarousel extends CarouselElement {
  static get requiredElements () {
    return ['slider', 'slide']
  }

  /** @returns {KeenSliderOptions} */
  get options () {
    return {
      selector: this.els.slide.selector,
      slides: {
        perView: 'auto',
        spacing: 10,
      },
      breakpoints: {
        '(min-width: 768px)': {
          spacing: 30,
        },
      },
    }
  }

  /** @returns {KeenSliderPlugin[]} */
  get plugins () {
    return [
      setInitialised(),
      useArrows({
        next: this.els.next?.element,
        previous: this.els.previous?.element,
      }),
      useScrollbar(this.externalEls?.scrollbar?.element),
    ]
  }
}

const viewportWidth =
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth

if (!customElements.get('product-carousel') && viewportWidth >= 768) {
  customElements.define('product-carousel', ProductCarousel)
} else if (viewportWidth < 768) {
  document.querySelectorAll('[data-product-carousel-el]').forEach(slider => {
    slider.classList.remove('keen-slider')
  })
}
